// extracted by mini-css-extract-plugin
export var attachmentContainer = "_n6-0";
export var fileList = "_n6-2";
export var removeFileButton = "_n6-1";